import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/Navbar/rwlogo.webp";
import { NavLink, Link, useLocation } from "react-router-dom";
import { ChevronUp, Menu, ArrowRight, BookOpen, Briefcase } from "lucide-react";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [AcademyOpen, setAcademyOpen] = useState(false);
  const [allCoursesOpen, setAllCoursesOpen] = useState(false);
  const [IndividualOpen, setIndividualOpen] = useState(false);
  const [individualSubOpen, setIndividualSubOpen] = useState(false);
  const [corporateSubOpen, setCorporateSubOpen] = useState(false);
  const [CorporateOpen, setCorporateOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [eventsOpen, setEventsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

  const getDesktopNavClass = (isActive) =>
    `flex items-center gap-1 text-base font-semibold transition-colors duration-200 ${
      isActive ? "text-[#3e59b7]" : "text-[#666666]"
    }`;

  const location = useLocation();
  const navRef = useRef();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setActiveDropdown(null);
  };
  useEffect(() => {
    setActiveDropdown(null);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) {
        setMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]);

  const toggleIndividual = () => {
    setIndividualOpen(!IndividualOpen);
    if (!IndividualOpen) {
      setIndividualSubOpen(false);
    }
  };

  const toggleCorporate = () => {
    setCorporateOpen(!CorporateOpen);
    if (!CorporateOpen) {
      setCorporateSubOpen(false);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu-item")) {
        closeMenus();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };
  const closeMenus = () => {
    setMenuOpen(false);
    setServicesOpen(false);
    setProductsOpen(false);
    setAcademyOpen(false);
    setCompanyOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
  };

  const toggleServices = () => {
    setServicesOpen(!servicesOpen);
    setProductsOpen(false);
    setAcademyOpen(false);
    setCompanyOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
    setSupportOpen(!false);
  };

  const toggleProducts = () => {
    setProductsOpen(!productsOpen);
    setServicesOpen(false);
    setCompanyOpen(false);
    setAcademyOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
    setSupportOpen(!false);
  };
  const toggleAcademy = () => {
    setAcademyOpen(!AcademyOpen);
    setServicesOpen(false);
    setCompanyOpen(false);
    setProductsOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
    setSupportOpen(!false);
  };
  const toggleCompany = () => {
    setCompanyOpen(!companyOpen);
    setServicesOpen(false);
    setProductsOpen(false);
    setAcademyOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
    setSupportOpen(!false);
  };

  const toggleResources = () => {
    setResourcesOpen(!resourcesOpen);
    setServicesOpen(false);
    setProductsOpen(false);
    setAcademyOpen(false);
    setCompanyOpen(false);
    setEventsOpen(false);
    setSupportOpen(!false);
  };

  const toggleEvents = () => {
    setEventsOpen(!eventsOpen);
    setServicesOpen(false);
    setProductsOpen(false);
    setCompanyOpen(false);
    setResourcesOpen(false);
    setSupportOpen(!false);
  };
  const toggleSupport = () => {
    setSupportOpen(!supportOpen);
    setServicesOpen(false);
    setProductsOpen(false);
    setAcademyOpen(false);
    setCompanyOpen(false);
    setResourcesOpen(false);
    setEventsOpen(false);
  };
  return (
    <>
      <nav
        ref={navRef}
        className="flex flex-col text-[#666666] lg:flex-row items-center justify-between font-display shadow-lg bg-white py-4 fixed top-0 left-0 right-0 z-50"
      >
        <article className="flex items-center w-full lg:w-auto lg:mr-auto">
          <NavLink
            to="/"
            className={({ isActive }) => getDesktopNavClass(isActive)}
          >
            <img
              src={logo}
              alt="Random Walk logo"
              className="lg:w-36 2xl:w-40 w-32 ml-2 h-8 lg:ml-5 md:mt-1 cursor-pointer"
            />
          </NavLink>

          <article
            className="lg:hidden flex items-center mr-5 lg:mr-0 ml-auto"
            onClick={toggleMenu}
          >
            <div className={`menu-icon ${menuOpen ? "open" : ""}`}>
              <div className="w-6 h-0.5 bg-gray-600 mb-1"></div>
              <div className="w-6 h-0.5 bg-gray-600 mb-1"></div>
              <div className="w-6 h-0.5 bg-gray-600"></div>
            </div>
          </article>
        </article>

        <div
          className={`lg:flex flex-grow justify-center ${
            menuOpen ? "block" : "hidden"
          } lg:items-center absolute lg:static top-full left-0 right-0 bg-white lg:bg-transparent lg:top-auto`}
        >
          <div className="flex flex-col mb-5 lg:mb-0 lg:flex-row lg:gap-14 2xl:gap-24 lg:items-center lg:justify-center lg:ml-20">
            <div
              className="hidden lg:block menu-item relative items-center"
              onClick={toggleProducts}
            >
              <NavLink
                to="/platform"
                className={({ isActive }) => getDesktopNavClass(isActive)}
              >
                Platforms
              </NavLink>
            </div>
            <div className="lg:hidden block menu-item relative w-full text-left">
              <NavLink
                to="/platform"
                className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
                onClick={() => {
                  closeMenu(); // close the dropdown
                  setMenuOpen(false); // ensure hamburger closes immediately
                }}
              >
                Platforms
              </NavLink>
            </div>

            <div
              className="hidden lg:block menu-item relative items-center"
              onClick={toggleProducts}
            >
              <NavLink
                to="/solutions"
                className={({ isActive }) => getDesktopNavClass(isActive)}
              >
                Solutions
              </NavLink>
            </div>

            <div className="lg:hidden block menu-item relative w-full mt-2 text-left">
              <NavLink
                to="/solutions"
                className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
                onClick={() => {
                  closeMenu(); // close the dropdown
                  setMenuOpen(false); // ensure hamburger closes immediately
                }}
              >
                Solutions
              </NavLink>
            </div>

            <div
              className="hidden lg:block menu-item relative items-center"
              onClick={toggleCompany}
            >
              <NavLink
                to="/usecases"
                className={({ isActive }) => getDesktopNavClass(isActive)}
              >
                Use Cases
              </NavLink>
            </div>
            <div className="lg:hidden block menu-item relative w-full text-left mt-2">
              <NavLink
                to="/usecases"
                className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
                onClick={() => {
                  closeMenu(); // close the dropdown
                  setMenuOpen(false); // ensure hamburger closes immediately
                }}
              >
                Use Cases
              </NavLink>
              {activeDropdown === "company" && (
                <div className="w-full">
                  <div className="flex flex-col text-sm py-2">
                    <NavLink
                      to="/about-us/"
                      onClick={closeMenus}
                      className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
                    >
                      About Us
                    </NavLink>

                    <NavLink
                      to="/careers/"
                      onClick={closeMenus}
                      className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
                    >
                      Careers
                    </NavLink>
                  </div>
                </div>
              )}
            </div>
            <div
              className="hidden lg:block menu-item relative items-center"
              onClick={toggleAcademy}
            >
              <a
                href="#"
                onClick={(event) => event.preventDefault()}
                className="flex items-center gap-1 text-base font-semibold text-[#666666] hover:text-[#3e59b7] transition-colors duration-200"
              >
                Academy<span className="text-xs leading-none">&#9662;</span>
              </a>
              {AcademyOpen && (
                <div className="absolute left-0 bg-white z-10 mt-1 shadow-lg rounded-md w-64">
                  <div className="text-sm flex flex-col">
                    <div
                      className="px-4 py-2 relative"
                      onMouseEnter={() => setAllCoursesOpen(true)}
                      onMouseLeave={() => setAllCoursesOpen(false)}
                    >
                      <NavLink
                        onClick={closeMenu}
                        to="/academy/for-individuals/"
                        className="block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white "
                      >
                        Artifical Intelligence Courses
                      </NavLink>
                      {allCoursesOpen && (
                        <div className="absolute left-60 top-2 ml-4 bg-white z-10 shadow-lg rounded-md text-nowrap">
                          <div className="px-4 py-2 text-sm flex flex-col">
                            <NavLink
                              to="/academy/for-individuals/"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              For Individuals
                            </NavLink>
                            <NavLink
                              to="/academy/for-corporates/"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              For Corporates
                            </NavLink>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="px-4 py-2 relative"
                      onMouseEnter={() => setIndividualOpen(true)}
                      onMouseLeave={() => setIndividualOpen(false)}
                    >
                      <NavLink
                        onClick={closeMenu}
                        to="/academy/career-advancement-courses/"
                        className="block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white "
                      >
                        Digital Skills Courses
                      </NavLink>
                      {IndividualOpen && (
                        <div className="absolute left-60 top-2 ml-4 bg-white z-10 shadow-lg rounded-md w-64">
                          <div className="px-4 py-2 text-sm flex flex-col">
                            <div className="mb-2 flex items-center">
                              For Individuals
                              <ArrowRight
                                className="ml-2 text-[#666666]"
                                size={16}
                              />
                            </div>
                            <NavLink
                              to="/academy/career-advancement-courses/"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              Career Change Certificate Course
                            </NavLink>
                            <NavLink
                              to="/academy/professional-growth-courses/"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              Elevate Professional Certificate Course
                            </NavLink>
                            <NavLink
                              to="/academy/bite-sized-courses/"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              Bite-sized Courses
                            </NavLink>

                            <div className="mt-4 mb-2 flex items-center">
                              Corporates
                              <ArrowRight
                                className="ml-2 text-[#666666]"
                                size={16}
                              />
                            </div>
                            <NavLink
                              to="/academy/workshops"
                              onClick={closeMenu}
                              className="block px-4 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                            >
                              Workshops
                            </NavLink>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="lg:hidden block menu-item relative w-full text-center">
              <div
                className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
                onClick={() => toggleDropdown("Academy")}
              >
                Academy{" "}
                <span className="ml-2 text-xs leading-none">&#9662;</span>
              </div>

              {activeDropdown === "Academy" && (
                <div className="w-full">
                  <div className="flex flex-col text-sm py-2">
                    <div className="relative">
                      <div
                        onClick={() => setAllCoursesOpen(!allCoursesOpen)}
                        className="flex items-center gap-x-2 w-full text-left pl-8 py-3 text-[rgba(62,89,183,1)] font-bold cursor-pointer"
                      >
                        <span>Artificial Intelligence Courses</span>
                        <span className="ml-2 text-xs leading-none">
                          &#9662;
                        </span>
                      </div>

                      {allCoursesOpen && (
                        <div className="text-sm text-left pl-0">
                          <NavLink
                            to="/academy/for-individuals/"
                            onClick={closeMenus}
                            className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                          >
                            For Individuals
                          </NavLink>
                          <NavLink
                            to="/academy/for-corporates/"
                            onClick={closeMenus}
                            className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                          >
                            For Corporates
                          </NavLink>
                        </div>
                      )}
                    </div>

                    <div className="relative">
                      <div
                        onClick={toggleIndividual}
                        className="flex items-center gap-x-2 w-full text-left pl-8 text-[rgba(62,89,183,1)] font-bold cursor-pointer"
                      >
                        <span>Digital Skills Courses</span>
                        <span className="ml-2 text-xs leading-none">
                          &#9662;
                        </span>
                      </div>

                      {IndividualOpen && (
                        <>
                          <div
                            onClick={() =>
                              setIndividualSubOpen(!individualSubOpen)
                            }
                            className="flex items-center gap-x-2 w-full text-left pl-8 py-3 text-black font-bold cursor-pointer"
                          >
                            <span>For Individuals</span>
                            <span className="ml-2 text-xs leading-none">
                              &#9662;
                            </span>
                          </div>

                          {individualSubOpen && (
                            <div className="text-left pl-0 text-sm">
                              <NavLink
                                to="/academy/career-advancement-courses/"
                                onClick={closeMenus}
                                className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                              >
                                Career Advancement Courses
                              </NavLink>
                              <NavLink
                                to="/academy/professional-growth-courses/"
                                onClick={closeMenus}
                                className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                              >
                                Professional Growth Courses
                              </NavLink>
                              <NavLink
                                to="/academy/bite-sized-courses/"
                                onClick={closeMenus}
                                className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                              >
                                Bite-sized Courses
                              </NavLink>
                            </div>
                          )}

                          <div
                            onClick={toggleCorporate}
                            className="flex items-center gap-x-2 w-full text-left pl-8 py-3 text-black font-bold cursor-pointer"
                          >
                            <span>For Corporates</span>
                            <span className="ml-2 text-xs leading-none">
                              &#9662;
                            </span>
                          </div>

                          {CorporateOpen && (
                            <>
                              <div className="text-left pl-0 text-sm">
                                <NavLink
                                  to="/academy/workshops"
                                  onClick={closeMenus}
                                  className="block px-8 py-2 hover:bg-[#B4BDFF] hover:text-white"
                                >
                                  Workshop
                                </NavLink>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              className="hidden lg:block menu-item relative items-center"
              onClick={toggleResources}
            >
              <a
                href="#"
                className="elementor-item text-base font-semibold elementor-item-anchor"
              >
                Resources
                <span className="ml-2 text-xs leading-none">&#9662;</span>
              </a>
              {resourcesOpen && (
                <div className="absolute top-full left-0 bg-white z-10 mt-1 shadow-lg rounded-md w-fit">
                  <div className="text-sm flex flex-col">
                    <div className="px-4 py-1">
                      <NavLink
                        to="/blog/"
                        onClick={closeMenu}
                        className="block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Blog
                      </NavLink>
                    </div>
                    <div className="px-4 py-1 pb-2">
                      <NavLink
                        to="/brochures/"
                        onClick={closeMenu}
                        className="text-nowrap block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Brochures
                      </NavLink>
                    </div>

                    <div className="px-4 py-1">
                      <NavLink
                        to="/podcasts/"
                        onClick={closeMenu}
                        className="block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Podcasts
                      </NavLink>
                    </div>
                    <div className="px-4 py-1 pb-2">
                      <NavLink
                        to="/webinars/"
                        onClick={closeMenu}
                        className="text-nowrap block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Webinars
                      </NavLink>
                    </div>
                    <div className="px-4 py-1 pb-2">
                      <NavLink
                        to="/media-futures/"
                        onClick={closeMenu}
                        className="text-nowrap block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Media Futures
                      </NavLink>
                    </div>
                    <div className="px-4 py-1 pb-2">
                      <NavLink
                        to="/playlab/"
                        onClick={closeMenu}
                        className="text-nowrap block px-2 py-2 rounded hover:bg-[#B4BDFF] hover:text-white"
                      >
                        Playlab
                      </NavLink>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="lg:hidden block menu-item relative w-full text-center">
        <div
          className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
          onClick={() => toggleDropdown("resources")}
        >
          Resources<span className="ml-2 text-xs leading-none">&#9662;</span>
        </div>
 
        {activeDropdown === "resources" && (
          <div className="w-full ">
            <div className="flex flex-col text-sm py-2">
              <NavLink
                to="/blog/"
                onClick={closeMenus}
                className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Blog
              </NavLink>
 
              <NavLink
                to="/brochures/"
                onClick={closeMenus}
                className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Brochures
              </NavLink>
 
           
               <NavLink
                to="/podcasts/"
                onClick={closeMenus}
                className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Podcasts
              </NavLink>
 
              <NavLink
                to="/webinars/"
                onClick={closeMenus}
                className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Webinars
              </NavLink>
 
              <NavLink
                to="/media-futures/"
                onClick={closeMenus}
                className="text-nowrap block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Media Futures
              </NavLink>
 
              <NavLink
                to="/playlab/"
                onClick={closeMenus}
                className="text-nowrap block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
              >
                Playlab
              </NavLink>
            </div>
          </div>
        )}
      </div>

            <div className="lg:hidden block menu-item relative w-full text-center">
              <div
                className="items-center text-left pl-4 cursor-pointer font-semibold text-base mt-2"
                onClick={() => toggleDropdown("support")}
              >
                Support{" "}
                <span className="ml-2 text-xs leading-none">&#9662;</span>
              </div>

              {activeDropdown === "support" && (
                <div className="w-full">
                  <div className="flex flex-col text-sm py-2 ">
                    <NavLink
                      to="/contact-us/"
                      onClick={closeMenus}
                      className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
                    >
                      Contact
                    </NavLink>

                    <NavLink
                      to="/privacy-policy/"
                      onClick={closeMenus}
                      className="block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
                    >
                      Privacy Policy
                    </NavLink>

                    <NavLink
                      to="/terms-of-service/"
                      onClick={closeMenus}
                      className="text-nowrap block w-full text-left pl-8 py-3 hover:bg-[#B4BDFF] hover:text-white"
                    >
                      Terms of Service
                    </NavLink>
                  </div>
                </div>
              )}
            </div>
            <div className="flex items-center ml-auto lg:block mr-5">
              <NavLink
                to="/contact-us/"
                className="inline-flex items-center justify-center rounded border border-[#2563eb] bg-white px-6 py-2 text-base font-semibold font-display text-[#2563eb] transition-colors duration-200 hover:bg-[#2563eb] hover:text-white"
                onClick={closeMenu}
              >
                Contact
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
